// extracted by mini-css-extract-plugin
export default {"productsListContainer":"Products_productsListContainer__P72R0","backToTop":"Products_backToTop__+El7r"};